/** @format */

import {useState} from 'react';

import {Typography, Box} from '@mui/material';

import SingleValueDisplay from './SingleValueDisplay';
import ArrowValueDisplay from './ArrowValueDisplay';
import {MAX_TEXT_LENGTH} from '../../constants';
import {ExpandIndicatorContainer, StyledExpandLess, StyledMoreHoriz} from './styles';
import {prepareDisplayTexts, isEmpty} from '../../helpers/textHelpers';

interface ValueChangeCellProps {
  valueBefore?: Record<string, unknown> | null;
  valueAfter?: Record<string, unknown> | null;
  type?: string;
  isExpandable?: boolean;
}

const ValueChangeCell = ({
  valueBefore,
  valueAfter,
  type,
  isExpandable = false,
}: ValueChangeCellProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (isEmpty(valueBefore) && isEmpty(valueAfter)) {
    return <Typography variant='body2'>—</Typography>;
  }

  const {beforeText, afterText} = prepareDisplayTexts(
    valueBefore,
    valueAfter,
    isExpandable,
    isExpanded,
    MAX_TEXT_LENGTH,
  );

  const handleClick = () => {
    if (isExpandable) {
      setIsExpanded(!isExpanded);
    }
  };

  const ExpandIndicator = () => {
    if (!isExpandable) return null;

    return (
      <ExpandIndicatorContainer>
        {isExpanded ? <StyledExpandLess /> : <StyledMoreHoriz />}
      </ExpandIndicatorContainer>
    );
  };

  const CellContent = () => {
    if (type === 'add') {
      return <SingleValueDisplay text={afterText} variant='after' />;
    }

    if (type === 'remove') {
      return <SingleValueDisplay text={beforeText} variant='before' />;
    }

    if (isEmpty(valueBefore) && !isEmpty(valueAfter)) {
      return <SingleValueDisplay text={afterText} variant='after' />;
    }

    const totalLength = beforeText.length + afterText.length;
    const isShortContent = totalLength <= MAX_TEXT_LENGTH;
    return (
      <ArrowValueDisplay
        beforeText={beforeText}
        afterText={afterText}
        isHorizontal={isShortContent}
      />
    );
  };

  return (
    <Box onClick={handleClick}>
      <CellContent />
      <ExpandIndicator />
    </Box>
  );
};

export default ValueChangeCell;
